export function SearchPageLink({ children, query, className, url }) {
  const link = query ? `/search?query=${encodeURIComponent(query)}` : url

  if (!link) return null
  return (
    <a href={link} className={className} aria-label={query}>
      {children}
    </a>
  )
}
